import React, { useEffect } from 'react';

import RedirectUtils from '../../system-utils/redirect-utils';

export const InvalidToken: React.FC = () => {
  const redirectHome = () => {
    RedirectUtils.redirectToBiBLoginPage();
  };

  useEffect(() => {
    redirectHome();
  }, []);

  return null;
};
